// Маршрутизация по hash: работает при раздаче статики любым веб-сервером и офлайн.

import { useEffect, useState, type AnchorHTMLAttributes, type ReactNode } from "react";

export type Route = { path: string; parts: string[]; query: URLSearchParams };

function read(): Route {
  const raw = location.hash.replace(/^#/, "") || "/";
  const [path, q = ""] = raw.split("?");
  return { path, parts: path.split("/").filter(Boolean), query: new URLSearchParams(q) };
}

export function useRoute(): Route {
  const [r, setR] = useState(read);
  useEffect(() => {
    const on = () => setR(read());
    window.addEventListener("hashchange", on);
    return () => window.removeEventListener("hashchange", on);
  }, []);
  return r;
}

export function navigate(path: string, query?: Record<string, string | number | undefined | null>): void {
  const q = new URLSearchParams();
  Object.entries(query || {}).forEach(([k, v]) => v !== undefined && v !== null && v !== "" && q.set(k, String(v)));
  const s = q.toString();
  location.hash = path + (s ? `?${s}` : "");
}

export function setQuery(patch: Record<string, string | number | undefined | null>): void {
  const r = read();
  const q = new URLSearchParams(r.query);
  Object.entries(patch).forEach(([k, v]) => (v === undefined || v === null || v === "" ? q.delete(k) : q.set(k, String(v))));
  const s = q.toString();
  history.replaceState(null, "", `#${r.path}${s ? `?${s}` : ""}`);
  window.dispatchEvent(new HashChangeEvent("hashchange"));
}

export function Link({ to, children, ...rest }: { to: string; children: ReactNode } & AnchorHTMLAttributes<HTMLAnchorElement>) {
  return (
    <a href={`#${to}`} {...rest}>
      {children}
    </a>
  );
}
